import { BehaviorSubject, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SplitPaneService {
  private _active: BehaviorSubject<boolean>;
  public active: Observable<boolean>;
  private _when: BehaviorSubject<boolean | string>;
  public when: Observable<boolean | string>;

  constructor() {
    this._active = new BehaviorSubject(true);
    this.active = this._active.asObservable();
    this._when = new BehaviorSubject('lg');
    this.when = this._when.asObservable();
  }

  /**
   * hide the split pane menu for all screen widths
   */
  public hide(): void {
    this._active.next(false);
  }

  /**
   * show the split pane menu for all screen widths
   */
  public show(): void {
    this.enable();
    this._when.next(true);
  }

  /**
   * reenable the split pane menu for large screen widths
   */
  public restore(): void {
    this.enable();
    this._when.next('lg');
  }

  private enable(): void {
    this._active.next(true);
  }
}
